import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL

export const getProviderInfo = createAsyncThunk("provdier/getProvidersInfo", async (token, thunkAPI) => {
  try {
    const res = await axios.get(
        `${BACKEND_URL}/provider/get-info`, {
            headers: { Authorization: `Bearer ${token}` },
        });
    console.log("getProviderInfo data", res.data.provider);
    return res.data.provider;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch providers info");
  }
});

export const updateProviderInfo = createAsyncThunk(
  "provider/updateProviderInfo",
  async ({ formData, token }, thunkAPI) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      };

      const data = new FormData();

      // Append fields dynamically (ignore undefined or blank values)
      for (const key in formData) {
        if (
          formData[key] !== undefined &&
          formData[key] !== null &&
          formData[key] !== ""
        ) {
          data.append(key, formData[key]);
        }
      }

      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/provider/update-info`,
        data,
        config
      );

      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to update provider info"
      );
    }
  }
);

export const providerVerify = createAsyncThunk(
  "provider/verification",
  async ({ formData, providerId }, thunkAPI) => {
    const type = "provider";
    try {
      const data = new FormData();
      data.append("file-input", formData.fileInputs.selfie);
      data.append("file-input", formData.fileInputs.front);
      data.append("file-input", formData.fileInputs.back);

      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/provider/verification/${type}/${providerId}`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to verify provider"
      );
    }
  }
);



const providerInfoSlice = createSlice({
  name: "providerInfo",
    initialState: {
      providersInfo: null,
      isVerified: false,
      loading: false,
      error: null,
    },
    extraReducers: (builder) => {
      builder
        .addCase(getProviderInfo.pending, (state) => {
            state.loading = true;
        })
        .addCase(getProviderInfo.fulfilled, (state, action) => {
            state.providersInfo = action.payload;
            state.isVerified = action.payload.is_verified === "Y";
            state.loading = false;
        })
        .addCase(getProviderInfo.rejected, (state, action) => {
            state.error = action.payload || "Failed to fetch providers"; 
            state.loading = false;
        })
        .addCase(updateProviderInfo.fulfilled, (state, action) => {
            state.providersInfo = action.payload;
            state.loading = false;
        })
    },
});

export default providerInfoSlice.reducer;